import { useState, useEffect, useRef } from 'react';
import { useNavigation } from 'react-router-dom';

const SPINNER_DELAY = 300; // ms to wait before showing spinner
const MIN_SPINNER_DURATION = 500; // ms to show spinner for

export function useSmartNavigation() {
  const [showSpinner, setShowSpinner] = useState(false);
  const navigation = useNavigation();
  const isLoading = navigation.state === 'loading';

  // ✨ Use useRef to store timer IDs. Initialize with null.
  const delayTimerRef = useRef<NodeJS.Timeout | null>(null);
  const minDurationTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isLoading) {
      // When loading starts, set a timeout to show the spinner.
      delayTimerRef.current = setTimeout(() => {
        setShowSpinner(true);
      }, SPINNER_DELAY);
    } else {
      // When loading ends, immediately clear the pending delay timer.
      if (delayTimerRef.current) {
        clearTimeout(delayTimerRef.current);
      }
      
      // And set a timeout to hide the spinner, ensuring it was visible for a minimum duration.
      minDurationTimerRef.current = setTimeout(() => {
        setShowSpinner(false);
      }, MIN_SPINNER_DURATION);
    }

    // The cleanup function will run when the component unmounts or `isLoading` changes.
    return () => {
      if (delayTimerRef.current) {
        clearTimeout(delayTimerRef.current);
      }
      if (minDurationTimerRef.current) {
        clearTimeout(minDurationTimerRef.current);
      }
    };
  }, [isLoading]);

  return { showSpinner };
}